<template>
  <v-container
    fluid
    v-if="nonConformity.id"
  >
    <div class="mb-5 d-flex justify-center">
      <avs-createButton
        @click.stop="handleCreateAction"
        :name="$t('actions.new_female', { entity: $t('commons.action').toLowerCase() })"
        :spantext="$t('actions.add', { entity: $t('commons.action').toLowerCase() })"
      >
      </avs-createButton>
    </div>

    <v-expansion-panels
      focusable
      v-model="panelOpen"
    >
      <v-expansion-panel
        v-for="(action, index) in this.actions"
        :key="index"
      >
        <v-expansion-panel-header class="d-flex align-center">
          <div class="d-flex align-center justify-space-between">
            <v-col cols="5">
              <span>{{ $tc("categories.nonconformity.action.name", 1) }} : {{ action.name }}</span>
            </v-col>

            <v-col cols="3">
              <span
                v-if="!isSaved[index]"
                class="d-flex align-center error--text"
              >
                <v-icon class="mr-2 error--text"> mdi-alert-outline </v-icon> Action not yet saved
              </span>
            </v-col>
            <v-col
              class="d-flex justify-end"
              cols="3"
            >
              <component :is="handleStatusComponent(action)" />
            </v-col>
            <avs-deleteButton
              @click.stop="handleRemoveAction(action, index)"
              :spantext="$t('actions.delete', { entity: $t('commons.action').toLowerCase() })"
            />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-2">
          <NonConformityAction
            :value="action"
            :isSaved="isSaved[index]"
            :nonConformity="nonConformity"
            :projectId="projectId"
            @update="v => handleActionUpdate(v, index)"
            @isSaved="v => updateIsSaved(v, index)"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { NonConformityService } from "@/services"
import { NonConformityAction } from "@/components"
import { mkNCAction } from "@/utils/datamodels"

export default {
  name: "NonConformityActionList",
  components: { NonConformityAction, Closed, Ongoing, Overdue, Pending },
  props: {
    nonConformity: {
      type: Object,
      required: true
    },
    projectId: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchAllActions()
  },
  data() {
    return {
      actions: [],
      isSaved: [],
      panelOpen: null
    }
  },
  methods: {
    handleCreateAction() {
      // Create new action from default, overwrite non_conformity value
      let action = mkNCAction(this.nonConformity.id, this.actions.length + 1)
      this.actions.push(action)
      this.isSaved.push(false)
      this.panelOpen = this.actions.length - 1
    },
    handleRemoveAction(action, index) {
      if (action.id) NonConformityService.deleteAction(action.id)
      this.actions.splice(index, 1)
      this.isSaved.splice(index, 1)
    },
    handleActionUpdate(action, index) {
      this.$set(this.actions, index, action)
    },
    handleStatusComponent(action) {
      return action.status
    },
    updateIsSaved(v, index) {
      this.$set(this.isSaved, index, v)
    },
    async fetchAllActions() {
      await NonConformityService.getAllActions(this.nonConformity.id)
        .then(response => {
          this.actions = response.results
          this.isSaved = Array(this.actions.length).fill(true)
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
    }
  },
  watch: {}
}
</script>
